// monitor #masthead for changes and set a custom property on the body element to indicate the header's height
/**
 * Header Observer
 */
function headerObserver() {
	const header = document.querySelector('#masthead');
	const observer = new ResizeObserver(function (entries) {
		entries.forEach(function (entry) {
			document.body.style.setProperty(
				'--header-height',
				`${entry.contentRect.height}px`
			);
		});
	});
	observer.observe(header);
}

export { headerObserver };
